// pages/testpdfuploadpage.js

import React, { useState } from 'react'

function TestPdfUploadPage() {
  const [file, setFile] = useState(null)
  const [uploading, setUploading] = useState(false)
  const [result, setResult] = useState('')
  const [pages, setPages] = useState([])

  const handleFileChange = (e) => {
    setFile(e.target.files[0])
    setResult('')
    setPages([])
  }

  const handleUpload = async () => {
    if (!file) {
      setResult('❌ Please select a file.')
      return
    }

    setUploading(true)
    setResult('Uploading and converting...')

    const formData = new FormData()
    formData.append('file', file)

    try {
      const res = await fetch('/api/upload-pdf-to-images', {
        method: 'POST',
        body: formData
      })

      const data = await res.json()

      if (data.success) {
        setPages(data.pages)
        setResult(`✅ Successfully converted ${data.pages.length} page(s).`)
      } else {
        setResult(`❌ Error: ${data.error}`)
      }
    } catch (err) {
      setResult(`❌ Upload failed: ${err.message}`)
    }

    setUploading(false)
  }

  return (
    <div style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
      <h2>🧪 Test PDF Upload & Conversion</h2>
      <input type="file" accept="application/pdf" onChange={handleFileChange} />
      <br /><br />
      <button onClick={handleUpload} disabled={uploading}>
        {uploading ? 'Processing...' : 'Upload & Convert'}
      </button>
      <pre style={{ marginTop: '2rem', whiteSpace: 'pre-wrap' }}>{result}</pre>

      {pages.length > 0 && (
        <>
          <h3>🖼️ Converted Pages</h3>
          <ul>
            {pages.map((page, index) => (
              <li key={index}>{page}</li>
            ))}
          </ul>
        </>
      )}
    </div>
  )
}

export default TestPdfUploadPage
